import { render, staticRenderFns } from "./RewardNo.vue?vue&type=template&id=72b66e2a&"
import script from "./RewardNo.vue?vue&type=script&lang=js&"
export * from "./RewardNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b66e2a')) {
      api.createRecord('72b66e2a', component.options)
    } else {
      api.reload('72b66e2a', component.options)
    }
    module.hot.accept("./RewardNo.vue?vue&type=template&id=72b66e2a&", function () {
      api.rerender('72b66e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardNo.vue"
export default component.exports